import { getPosition, URLEncodeParams } from './helpers'
import { COLLECTIONS } from './constants'

async function savePoinData (resource, bodyData) {
  const url = `/django/api/v1/${resource}`

  const response = await fetch(url, {
    method: 'POST',
    mode: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData)
  })
  return response.json()
}

async function fetchPoinData (resource, queryParams) {
  let url = `/django/api/v1/${resource}`

  if (queryParams) url += `?${URLEncodeParams(queryParams).toString()}`
  console.log('url', url)
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return response.json()
}

async function fetchWPData (resource, queryParams) {
  let url = `/wp-json/wp/v2/${resource}`

  if (queryParams) {
    url += '?'
    Object.keys(queryParams).forEach((p) => {
      url += `${p}=${queryParams[p]}&`
    })
    url = url.slice(0, url.length - 1)
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return response.json()
}

export async function saveUserSearches (searchText, searchPage, searchFilters) {
  const bodyData = {
    search_text: searchText,
    search_page: searchPage,
    search_filters: searchFilters,
    browser_data: {
      hostname: window.location.hostname,
      pathname: window.location.pathname,
      referrer: document.referrer,
      previous_sites: history.length,
      browser_language: navigator.language,
      browser_online: navigator.onLine,
      broswer_platform: navigator.platform,
      cookies_enabled: navigator.cookieEnabled,
      screen_width: screen.width,
      screen_height: screen.height,
      inner_width: innerWidth,
      inner_height: innerHeight
    }
  }
  try {
    const position = await getPosition()
    bodyData.latitude = position.coords.latitude
    bodyData.longitude = position.coords.longitude
  } catch (err) {
    console.error(err)
    bodyData.latitude = null
    bodyData.longitude = null
  }
  return savePoinData('user_searches', bodyData)
}

export function fetchAttributes (activeFor = COLLECTIONS.PLACES) {
  const queryParams = {
    ordering: 'human_name'
  }
  switch (activeFor) {
    case COLLECTIONS.ACTIVITIES_ENTERTAINMENT:
      queryParams.active_activities = true
      break
    case COLLECTIONS.SERVICES:
      queryParams.active_services = true
      break
    case COLLECTIONS.PLACES:
    default:
      queryParams.active_places = true
      break
  }

  return fetchPoinData('attributes/', queryParams)
}

export function fetchRatingCategories () {
  const queryParams = {
    ordering: 'human_name'
  }
  return fetchPoinData('rating_categories/', queryParams)
}

export function fetchSearchCategories () {
  return fetchPoinData('search_categories/')
    .then((response) => {
      const SORT_ORDER = {
        entertainment: 1,
        extracurricular: 2,
        eat: 3,
        services: 4,
        outdoors: 5,
        life_with_kids: 6,
        online: 7
      }

      return response.sort((a, b) => SORT_ORDER[a.code_name] - SORT_ORDER[b.code_name])
    })
}

export function fetchPlaces (queryParams) {
  return fetchPoinData('places/', queryParams)
}

export function fetchActivitiesEntertainment (queryParams) {
  queryParams.is_entertainment = true
  return fetchPoinData('activities/', queryParams)
}

export function fetchActivitiesServices (queryParams) {
  queryParams.is_service = true
  return fetchPoinData('activities/', queryParams)
}

export function fetchMunicipalities () {
  return fetchPoinData('municipalities')
}

export function fetchCampaigns () {
  return fetchPoinData('campaigns/')
}

export function fetchWPBlogPosts (queryParams) {
  return fetchWPData('posts', queryParams)
}

export function fetchItemsFromMainCollections (collection, queryParams) {
  switch (collection) {
    case COLLECTIONS.ACTIVITIES_ENTERTAINMENT:
      return fetchActivitiesEntertainment(queryParams)
    case COLLECTIONS.SERVICES:
      return fetchActivitiesServices(queryParams)
    case COLLECTIONS.PLACES:
    default:
      return fetchPlaces(queryParams)
  }
}
